import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from "./ui/button";
import { Calendar, ArrowRight } from "lucide-react";

gsap.registerPlugin(ScrollTrigger);

export const BookCall = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(contentRef.current, {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 md:py-28 bg-concrete/30 border-y border-border/50"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div ref={contentRef} className="text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-foreground/5 mb-8">
            <Calendar className="w-7 h-7 text-foreground" />
          </div>

          {/* Title */}
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Ready to Start a Project?
          </h2>

          {/* Description */}
          <p className="text-muted-foreground text-lg mb-10 max-w-2xl mx-auto">
            Book a free 30-minute discovery call to discuss your technology infrastructure needs, 
            real estate investments, or digital transformation projects.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={() => window.open('https://calendly.com/jeremie-lictevoet', '_blank')}
              className="group bg-foreground text-background hover:bg-foreground/90 px-8 py-6 text-sm uppercase tracking-widest font-medium"
            >
              <Calendar className="mr-2 w-4 h-4" />
              Book a Call
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-foreground text-foreground hover:bg-foreground hover:text-background px-8 py-6 text-sm uppercase tracking-widest font-medium"
            >
              Send a Message
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookCall;
